import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { learningTools, MOCKUP_URL } from '../../data/content';
export function Tools() {
  return <section className="bg-navy px-4 py-16 sm:py-24" data-id="element-274" data-mp="2mjxgz6tlgq6o">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-275" data-mp="2hj9vt1s1r3kd">
        <div data-id="element-276" data-mp="2dizeisyt0qq7">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-electric sm:text-sm" data-id="element-277" data-mp="2dhejl28kv5rt">More than just six ebooks</p>
          <h2 className="text-balance mt-3 font-display text-[30px] font-black leading-[1.08] tracking-tight text-white sm:text-5xl" data-id="element-278" data-mp="28kxxseoup3hw">
            Practical Tools You Can Use During Clinical Planning
          </h2>
          <p className="mt-4 text-base text-white/75 sm:text-lg" data-id="element-279" data-mp="1yrh2t7cz9icn">
            The library is organized around five complementary learning resources:
          </p>
          <ul className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-280" data-mp="1pru1elk90cjl">
            {learningTools.map(({
            icon: Icon,
            title,
            text
          }) => <li key={title} className="flex gap-4 py-4" data-id="element-281" data-mp="159g63mwe13i6">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-electric/15 text-electric" data-id="element-282" data-mp="157wpfv6tkqfv">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-283" data-mp="1a20x6gnwt2i0" />
                </span>
                <div data-id="element-284" data-mp="wamanzusmj67">
                  <h3 className="font-display text-lg font-extrabold text-white" data-id="element-285" data-mp="10ad0a08l2t95">{title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-286" data-mp="1080hxlywygvk">{text}</p>
                </div>
              </li>)}
          </ul>
          <p className="mt-6 font-semibold text-electric-light" data-id="element-287" data-mp="1sxr2acr52f04">
            Everything organized to make complex biomechanics easier to review.
          </p>
        </div>
        <div className="rounded-3xl bg-[#EAF3FF] p-3 sm:p-5" data-id="element-288" data-mp="1jxufyhs81s88">
          <img src={MOCKUP_URL} alt="Diagrams, decision maps and illustrations included in the library" className="h-auto w-full" loading="lazy" data-id="element-289" data-mp="1k06yaw1w64lt" />
        </div>
      </div>
      <SectionCTA label="Unlock all the visual tools now" data-id="element-290" data-mp="8ks2hvlf5isa" />
    </section>;
}